var map = {
	"./img_1.jpg": 98913,
	"./img_2.jpg": 19184,
	"./img_3.jpg": 94616,
	"./img_4.jpg": 319,
	"./img_5.jpg": 1723,
	"./img_6.jpg": 14936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46081;